import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const ModalSuccessRoot = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'clearfix bottom-0 left-0 right-0 top-0 z-[101] m-0 flex h-full items-center justify-center bg-screen',
      className
    )}
    {...props}
  />
)
